import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/liste/Liste.vue'),
		meta: {
			title: 'liste',
			acl: 'section.liste'
		}
	},
	{
		path: 'view/:id',
		component: () => import('@/views/liste/ListItems.vue'),
		meta: {
			title: 'elementi-lista',
			acl: 'section.liste'
		}
	}
];

export default routes;